import 'twin.macro';
import 'styled-components/macro';
import { Link, generatePath, useHistory } from 'react-router-dom';

import { ButtonV2 } from 'component-lib/atoms/button-v2/ButtonV2';
import { useShoppingCartContext } from 'toy/context/ShoppingCart';
import { Sweet } from 'types/graphql-toy';

import { AverageRating } from '../../atoms/average-rating/AverageRating'; // TODO: move this component to atoms
import { SmartFavoritiesToggle } from '../../molecules/smart-favorites-toggle/SmartFavoritiesToggle';

export type SweetCardItem = Pick<Sweet, 'id' | 'title' | 'created_at' | 'expires_at'> & {
  rating: number;
  votes: number;
};

export interface SweetCardProps {
  item: SweetCardItem;
}

export const SweetCard = ({ item }: SweetCardProps) => {
  const { addToCart } = useShoppingCartContext();
  const history = useHistory();

  return (
    <div tw="rounded ring-1 ring-gray-15 bg-white p-2">
      <h2 tw="display-2 mb-2 flex items-center">
        <Link tw="flex-grow" to={`/toy-shop/sweet/${item.id}`}>
          {item.title}
        </Link>

        <SmartFavoritiesToggle id={item.id} />
      </h2>

      <AverageRating
        rating={item.rating}
        votes={item.votes}
        onClick={() => {
          history.push(generatePath('/toy-shop/sweet/:id', { id: item.id }));
        }}
      />

      <ButtonV2 tw="w-full" onClick={() => addToCart({ id: item.id, title: item.title, expiresAt: item.expires_at })}>
        Add to cart
      </ButtonV2>
    </div>
  );
};
